import classNames from 'classnames';
import React, { useEffect } from 'react';

import MultiSelectDropdown from '../../../components/MultiSelectDropdown/MultiSelectDropdown';
import useVoucherContext, { VoucherFilterType } from './useVoucherContext';

export type VoucherFilterProps = {
  label?: string;
  labelFilter?: boolean;
  labelClassName?: string;
  filterClassName?: string;
  filterType?: VoucherFilterType[];
  showClearFilter?: boolean;
  filtersOccupyWidth?: boolean;
  hideFiltersOnDefault?: boolean;
};

const VoucherFilter = ({
  label = 'View by',
  labelFilter = false,
  labelClassName,
  filterClassName,
  filterType = [VoucherFilterType.STATUS],
  showClearFilter = false,
  filtersOccupyWidth = true,
  hideFiltersOnDefault = true,
}: VoucherFilterProps) => {
  const {
    filters: { selectedFilters, setSelectedFilters, selectedStatus, setSelectedStatus, statusOptions },
  } = useVoucherContext();
  useEffect(() => {
    if (!hideFiltersOnDefault) {
      setSelectedFilters(filterType);
    }
    setSelectedStatus(Object.values(statusOptions));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusOptions]);

  const handleClearFilterType = (removeFilter: VoucherFilterType) => {
    setSelectedFilters(
      selectedFilters.includes(removeFilter)
        ? selectedFilters.filter((filter) => filter !== removeFilter)
        : selectedFilters
    );
  };

  return (
    <div
      className={classNames('flex gap-x-3 lg:flex-row', filterClassName, filtersOccupyWidth ? 'flex-col' : 'flex-row')}
    >
      <div className={classNames('lg:mb-0', labelFilter ? 'mb-4' : 'content-center')}>
        {labelFilter ? (
          <>
            <MultiSelectDropdown
              options={Object.fromEntries(filterType.map((filter) => [filter, filter]))}
              selectedOptions={selectedFilters}
              placeholder={label}
              onChange={setSelectedFilters}
              reflectParentOptionsState={true}
              showSelected={false}
              showClearIcon={false}
              buttonClassName="!w-auto !border-none !pl-0 !pr-3"
              labelClassName={`text-base ${labelClassName}`}
              dropdownClassName="!w-auto !min-w-[120px] !p-3"
              // showSelectAll={false}
            />
          </>
        ) : (
          <span className={classNames('text-base', labelClassName)}>{label}</span>
        )}
      </div>
      <div
        className={classNames(
          'grid gap-x-2 gap-y-2 lg:flex lg:flex-row',
          filtersOccupyWidth ? 'grid-cols-2' : 'grid-cols-1'
        )}
      >
        <div
          className={classNames('mr-2', selectedFilters.includes(VoucherFilterType.STATUS) ? 'inline-block' : 'hidden')}
        >
          <MultiSelectDropdown
            options={Object.fromEntries(statusOptions.map((status) => [status, status]))}
            selectedOptions={selectedStatus}
            placeholder="Status"
            onChange={setSelectedStatus}
            buttonClassName="!w-auto rounded-[32px] !border-none bg-[#E7E9E9]"
            labelClassName="text-base"
            selectedClassName="text-base"
            dropdownClassName="!w-auto !min-w-[120px] !p-3"
            onClear={() => handleClearFilterType(VoucherFilterType.STATUS)}
            keyAsLabel={true}
            showClearIcon={showClearFilter}
          />
        </div>
      </div>
    </div>
  );
};

export default VoucherFilter;
